import React, { useEffect, useRef, useState } from 'react';
import { Helmet } from "react-helmet";
import Navbarsynergtech from '../Navbarsynergtech/Navbarsynergtech';
import Header11 from '../Header11/Header11';
import Banner1 from '../Banner1/Banner1';
import SolutionServices from '../SolutionServices/SolutionServices';
import ServicesPartner from '../ServicesPartner/ServicesPartner';
import ProjectCounts from '../ProjectCounts/ProjectCounts';
import Technology from '../TechnologyIndex/Technology';
import EstimateProject from '../EstimateProject/EstimateProject';
import Appointment from '../Appointment/Appointment';
import WebPageExperience from "../../WebsiteDeploymentServices/WebPageExperience/WebPageExperience";
import FooterAll from '../FooterAll/FooterAll';
import Footer from '../Footer/Footer';
// Imported directly rather than via React.lazy/Suspense: a Suspense fallback ("Loading...") on the first client
// render can never match the prerendered HTML, which already contains these sections.
import Tips from '../Tips/Tips';
import Customers from '../Customers/Customers';
import Faqs from '../Faqs/Faqs';
import HomepageMergeStyles from './HomepageMerge.css'; // Assuming you have a CSS file for styles


function HomepageMerge() {
  const [isVisible, setIsVisible] = useState(false);
  const appointmentRef = useRef(null);

  const scrollToAppointment = () => {
    if (appointmentRef.current) {
      appointmentRef.current.scrollIntoView({ behavior: 'instant' });
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    let lastScrollY = window.pageYOffset;
    const toggleVisibility = () => {
      const currentScrollY = window.pageYOffset;
      if (Math.abs(currentScrollY - lastScrollY) > 50) { 
        setIsVisible(currentScrollY > 300);
        lastScrollY = currentScrollY;
      }
    };

    window.addEventListener('scroll', toggleVisibility, { passive: true });
    scrollToTop();
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  return (
    <div>
      <Helmet>
        
        <title>Custom Software, AI & Cloud Solutions | 360 SynergyTech</title>
        <link rel="canonical" href="https://360synergytech.com/" />
        <meta name="description" content="360 SynergyTech offers custom software, AI solutions, and cloud services to drive your business growth. Partner with us and innovate smarter today!" />

        <meta property="og:title" content="Custom Software, AI & Cloud Solutions | 360 SynergyTech" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://360synergytech.com/" />
        <meta property="og:image" content="https://360synergytech.com/synergy-logo.png" />
        <meta property="og:description" content="360 SynergyTech delivers cutting-edge IT services, including software development, AI, cloud, and digital transformation solutions for businesses worldwide." />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Custom Software, AI & Cloud Solutions | 360 SynergyTech" />
        <meta name="twitter:description" content="Trusted partner for AI, cloud, software engineering, and digital transformation services." />
        <meta name="twitter:image" content="https://360synergytech.com/synergy-logo.png" />

        {/* Organization/WebSite JSON-LD is provided sitewide by the static block in
            public/index.html (kept as the single source of truth to avoid duplicate/
            conflicting Organization schema on this page). */}
      </Helmet>
      <>
        {isVisible && (
          <button onClick={scrollToTop} className="scroll-to-top-button" aria-label="Scroll to top">
            <span>↑</span>
          </button>
        )}
      </>
      <Navbarsynergtech scrollToAppointment={scrollToAppointment} />
      <Header11 appointmentRef={appointmentRef} />
      <Banner1 />
      <SolutionServices />
      <WebPageExperience />
      <ServicesPartner />
      <ProjectCounts />
      <Technology />
      <Tips />
      <EstimateProject scrollToAppointment={scrollToAppointment} />
      <Customers />
      <div className="section-gap"></div> {/* Added to create a gap */}
      <Faqs scrollToAppointment={scrollToAppointment} />
      <div ref={appointmentRef}>
        <Appointment />
      </div>
      <FooterAll />
      <Footer />
    </div>
  );
}

export default HomepageMerge;